import React from 'react';
function ArrowH({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 17.25L12 21l-3.75-3.75M12 3v18M15.75 6.75L12 3 8.25 6.75"
      />
    </svg>
  );
}

export default ArrowH;
